import React from "react";

import sentiment_up from "./../../i/icons/sentiment_up.svg";
import sentiment_down from "./../../i/icons/sentiment_down.svg";

import Heading from "../Elements/Heading.js";
import moment from "moment";
import { formatInsightText } from "./../Utils/InsightsUtils.js";

const InsightLatest = props => {
  const {
    insight_text_markup,
    insight_markup_array,
    insight_timestamp,
    insight_sentiment,
    insight_generation_time
  } = props;

  const classes = ["row mb-4 insight"];

  const sentiment_direction =
    insight_sentiment === "positive"
      ? sentiment_up
      : insight_sentiment === "negative"
      ? sentiment_down
      : null;

  return (
    <section className={classes}>
      <div className="col-12">
        <time className="insight__time">
          {moment
            .utc(insight_timestamp)
            .local()
            .format("MM/DD/YY")}{" "}
          -{" "}
          {moment
            .utc(insight_generation_time)
            .local()
            .format("HH:mm")}
        </time>
        <img
          src={sentiment_direction}
          alt={sentiment_direction}
          className="ml-2"
        />
        <Heading size={4} className={"insight__text mb-2"}>
          <span
            dangerouslySetInnerHTML={{
              __html: formatInsightText(
                insight_markup_array,
                insight_text_markup
              )
            }}
          />
        </Heading>
      </div>
    </section>
  );
};

export default InsightLatest;
